import { createApp } from 'vue'
import ergon from './ergon'
import {FormTracker} from "@/form-tracker";
import {DynamicsFormHandler} from "@/dynamics-form-handler";
import ShareButtons from '@/share-buttons';

document.addEventListener('DOMContentLoaded', () => {
    ShareButtons();
});

const app = createApp({})

app.use(ergon)

// IMPORTANT FOR GREENBARS
app.config.compilerOptions.comments = true

app.mount('#app')

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const formTracker = new FormTracker(["form"])
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const dynamics = new DynamicsFormHandler(".lz-js-dynamics-form");

declare module 'vue' {
    interface ComponentCustomProperties {
        $contextPath: string
    }
}

declare global {
    interface Window {
        contextPath: string;
        dataLayer: Record<any, any>[];
    }
}
